import styled from 'styled-components';

export const DuplicatePromotionThumbnail = styled.div<{ background: string }>`
  width: 100%;
  height: 100%;
  background: ${({ background }) => `url(${background})`};
  background-size: cover;
`;
